<template>
  <section :class="['video-wrap', { ee: storeName.EE }]">
    <video width="100%" :autoplay="autoplay" :loop="loop" :muted="muted">
      <source
        v-for="item in video"
        :key="item.id"
        :src="item.url"
        :type="item.type"
      />
    </video>
    <img :src="logoUrl" />
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "main-video",
  props: {
    video: {
      type: Array,
      required: true,
    },
    logoUrl: {
      type: String,
      required: false,
    },
    autoplay: {
      type: Boolean,
      required: false,
    },
    loop: {
      type: Boolean,
      required: false,
    },
    muted: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.video-wrap {
  &.ee {
    display: flex;
    position: relative;
    > img {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translate(0, -50%);
      width: 30%;
    }
  }
}
</style>
